import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@emotion/react";

const PaginationDot = (props) => {
  const { index, active, onClick } = props;
  const theme = useTheme();

  const styles = {
    root: {
      height: 18,
      width: 18,
      cursor: "pointer",
      border: 0,
      background: "none",
      padding: 0,
    },
    dot: {
      backgroundColor: "#e4e6e7",
      height: 12,
      width: 12,
      borderRadius: 6,
      margin: 3,
    },
    active: {
      backgroundColor: theme.palette.primary.main,
    },
  };

  const handleClick = (event) => {
    onClick(event, index);
  };

  let styleDot;

  if (active) {
    styleDot = { ...styles.dot, ...styles.active };
  } else {
    styleDot = styles.dot;
  }

  return (
    <button
      type="button"
      style={styles.root}
      onClick={handleClick}
      aria-label={`Pagination dot ${index + 1}`}
    >
      <div style={styleDot} />
    </button>
  );
};

PaginationDot.propTypes = {
  active: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PaginationDot;
